<template>
  <div class="download">
    <signboard signboardName="账单模板"></signboard>
    <div class="content df">
      <!-- v-if="key != 0 && key < 4" -->
      <div
        class="template-item"
        v-for="(item, key) in info"
        :key="key"
        :class="
          item.isTemplate ? 'template-item-border' : 'template-item-border2'
        "
      >
        <div
          :class="
            key == 0 ? 'template-item-background1' : 'template-item-background2'
          "
        >
          <img
            v-if="item.isTemplate"
            class="default"
            src="../../../assets/picture/star.png"
            alt=""
          />
          <div>
            <div class="item-title">{{ item.templateName }}</div>
            <div class="item-content gray-word">
              包含字段：{{ item.nameKye }}
            </div>
            <div class="btn">
              <el-button type="primary" size="small" @click="out(item)">{{
                key == 0 ? "查看" : "编辑"
              }}</el-button>
              <el-button
                @click.stop="SetAsTheDefaultTemplate(item)"
                type="text"
                size="small"
                :disabled="item.isTemplate == 1"
                >{{
                  item.isTemplate == 0 ? "设为默认模板" : "作为默认模板"
                }}</el-button
              >
              <el-popover placement="bottom" width="" v-model="item.length">
                <div
                  style="padding: 0px 0; text-align: center"
                  @click="deleteTemplate(item.id)"
                >
                  删除模版
                </div>
                <img
                  @click.stop="ISdeleteTemplate"
                  class="delete"
                  slot="reference"
                  v-if="key != 0"
                  src="../../../assets/picture/delete.png"
                  alt=""
                />
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div
        class="template-item template-item-background3"
        v-if="info.length < 4"
        @click="add"
      >
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import API from "@/api/setTing";
const api = new API();

export default {
  components: { signboard },
  data() {
    return {
      info: [],
    };
  },
  methods: {
    async deleteTemplate(id) {
      let parme = {
        id: id + "",
      };
      let res = await api.deleteTemplate(parme);
      console.log(res);
      if (res.success) {
        this.$message({
          message: res.errorMessage,
          type: "success",
        });
        this.selectCustomTemplate();
      }
    },
    SetAsTheDefaultTemplate(item) {
      this.updateIsTemplate(item);
    },
    out(i) {
      this.$router.push({ path: "/setTing/download" });
      // 通过sessionStorage给子页面传参
      sessionStorage.setItem("setTingItem", JSON.stringify(i));
      localStorage.setItem("setTingItem", JSON.stringify(i));
    },
    async add() {
      console.log("添加模板");
      console.log(this.info[0].attribute,9999999);
      const parme = {
        attribute: this.info[0].attribute,
        isCommon: 0,
        isDiscount: 0,
        isTemplate: 0,
        sortRule: "goods_name",
        templateName: "模板" + this.info.length,
        userId: this.info[0].userId,
      };
      const res = await api.updateTemplate(parme);
      console.log(res);
      if(res.success){
        this.$message({
          message: res.errorMessage,
          type: "success",
        });
      }
      this.selectCustomTemplate();
      // this.$router.push({ path: "/setTing/download" });
      // sessionStorage.setItem('setTingItem',JSON.stringify(i))
    },

    async updateIsTemplate(item) {
      console.log(item);
      let parme = {
        id: item.id + "",
      };
      const res = await api.updateIsTemplate(parme);
      console.log(res);
      if (res.success == true) {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        setTimeout(() => {
          // this.$router.go(0)
          this.selectCustomTemplate();
        }, 200);
      }
    },
    async selectCustomTemplate() {
      let parme = {};
      const res = await api.selectCustomTemplate(parme);
      res.map((i) => {
        i.nameKye = "";
        JSON.parse(i.attribute).map((k) => {
          k.fieldDOList.map((j) => {
            if (j.disable == 1) {
              i.nameKye = i.nameKye + j.fieldValue + "/";
            }
          });
        });
      });
      this.info = JSON.parse(JSON.stringify(res));
    },
  },
  created() {
    this.selectCustomTemplate();
  },
};
</script>

<style lang='less' scoped>
.download {
  width: 100%;
  height: 100%;
  font-size: 14px;
  .content {
    padding: 16px 32px;
    .template-item {
      position: relative;
      margin-right: 32px;
      width: 262px;
      border-radius: 4px;
      text-align: left;
      .delete {
        height: 17px;
        position: absolute;
        bottom: 23px;
        right: 14px;
      }
    }
    .item-title {
      color: #323233;
      font-weight: 600;
      padding: 16px 16px 0 16px;
    }
    .item-content {
      padding: 4px 16px 0px 16px;
      margin-bottom: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .btn {
      padding: 0 16px 16px 16px;
    }
    .template-item-background1 {
      border-radius: 4px;
      background: #f4f4f4;
    }
    .template-item-background2 {
      height: 138px;
      background: #ffffff;
      border-radius: 4px;
      // box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    }
    .template-item-background3 {
      height: 144px;
      border: 1px solid #ececec;
      background: #fafafa;
      font-size: 38px;
      color: #7f838d;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .template-item-border {
      border: 2px solid #008cff;
    }
    .template-item-border2 {
      border: 1px solid #ececec;
    }
    .default {
      position: absolute;
      width: 14px;
      height: 14px;
      right: 9px;
      top: 8px;
    }
  }
}
</style>